module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', {
    staticClass: "title is-2"
  }, [_vm._v("Videos")]), _vm._v(" "), _c('div', {
    staticClass: "field search"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "search",
      "placeholder": "search"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })])]), _vm._v(" "), (!_vm.loading && _vm.resultVideos.length > 0) ? _c('ul', _vm._l((_vm.resultVideos), function(video) {
    return _c('FileVideo', {
      key: video.id,
      attrs: {
        "id": video.id,
        "thumbnail": video.thumbnail || video.user.avatar_url,
        "title": video.title
      }
    })
  })) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.resultVideos.length === 0 && _vm.query === '') ? _c('p', [_vm._v("No videos")]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.resultVideos.length === 0 && _vm.query !== '') ? _c('p', [_vm._v("No videos found matching "), _c('strong', [_vm._v(_vm._s(_vm.query))])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-a32bd446"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FilesVideos.vue
// module id = 1077
// module chunks = 0